
// ! rename the function to align with the widget name
export const sonataToplineMeta = (data) => {
    const el = document.querySelector('.curious-sonata-topline-meta');
    if (!el) return;

    // ------------------------------------------------------------

    const metaContainer = el.querySelector('.meta-container');

    
    const formattedData = {}
    
    data.info.map(item => {
        formattedData[item.label] = item.value
    })

    const toplineMeta = [
        {
            key: 'Number of Witnesses',
            value: data.variations.length,
            show: data.variations.length > 0,
        },
        {
            key: 'Control Witness',
            value: data.control.collection.name,
            show: data.control.collection.name !== '',
        },
        
        {
            key: 'Title',
            value: formattedData['Title'],
            show: formattedData['Title'] !== '',
        },
        {
            key: 'Home Key',
            value: formattedData['Home Key'],
            show: formattedData['Home Key'] !== '',
        },
        {
            key: 'Key Signature',
            value: formattedData['Key signature'],
            show: formattedData['Key signature'] !== '',
        },
        
        {
            key: 'Tempo',
            value: formattedData['Tempo'],
            show: formattedData['Tempo'] !== '',
        },
        {
            key: 'Time Signature',
            value: formattedData['Time signature'],
            show: formattedData['Time signature'] !== '',
        },
    ]

    console.log(toplineMeta)

    const html = toplineMeta.map(item => {
        if(item.show) {
            return `
            <div class="meta">
                <strong>${item.key}: </strong>
                <span>${item.value}</span>
            </div>
            `
        }
    }).join('');
    metaContainer.innerHTML = html;

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

